import EfHeaderV2 from 'eco-design/section-layout/ef-header-v2';
import { BhHeaderV2Lang } from 'eco-design/section-layout/ef-header-v2/BhHeaderV2Lang';

const HeaderV3 = ({ headerList = {}, locale }: { headerList: any; locale: string }) => {
    const theme = 'black';
    const TextHeader = BhHeaderV2Lang[locale] || BhHeaderV2Lang['en'];
    return (
        <>
            <EfHeaderV2 locale={locale} navItems={headerList.detailList} theme={theme} TextHeader={TextHeader} />
        </>
    );
};

export default HeaderV3;
